import { AbstractModel } from '@/models/base'
import type { IOrganization, IOrganizationData } from './organization.types'

export class Organization extends AbstractModel implements IOrganization {
  readonly id?: string
  readonly name: string
  readonly signed_required_documents: boolean = false

  constructor(data: IOrganizationData) {
    super()

    // Validate data
    const requiredFields: (keyof IOrganizationData)[] = ['name']
    this.validate(data, requiredFields)

    // Initialize object assuming data valid
    this.name = data.name!

    if (data.id) {
      this.id = data.id
    }

    if (data.signed_required_documents) {
      this.signed_required_documents = data.signed_required_documents
    }
  }
}
